import React from 'react';
import { Helmet } from 'react-helmet';

// eslint-disable-next-line react/prop-types
const Header = ({ shopName, barberName }) => (
  <div className="u-pt-30 u-pr-4 u-pl-4 u-mb-4 u-text-small u-co-grey--light u-ta-center">
    <Helmet>
      <title>Appointment Updated | {shopName}</title>
    </Helmet>
    {barberName}&apos;s appointment was updated
  </div>
);

export default Header;



// WEBPACK FOOTER //
// ./src/app/notifications/shop/ShopUpdatedAppointment/components/Header.jsx